import React from 'react'
import { withIcon } from '../../withIcon'

interface RemoveUserIconProps {
  size?: string
  color?: string
}

function RemoveUserIcon (props: RemoveUserIconProps) {
  const {
    size = '16px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none">
      <g transform="translate(1.5, 2)">
        <path d="M9.75 10.75C9.75 9.97469 9.75 9.58703 9.65312 9.27159C9.43498 8.56136 8.87224 8.00558 8.15314 7.79013C7.83376 7.69444 7.44125 7.69444 6.65625 7.69444H3.84375C3.05875 7.69444 2.66624 7.69444 2.34686 7.79013C1.62776 8.00558 1.06502 8.56136 0.846885 9.27159C0.75 9.58703 0.75 9.97469 0.75 10.75M7.78125 3.25C7.78125 4.63071 6.64797 5.75 5.25 5.75C3.85203 5.75 2.71875 4.63071 2.71875 3.25C2.71875 1.86929 3.85203 0.75 5.25 0.75C6.64797 0.75 7.78125 1.86929 7.78125 3.25Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <line x1="14" y1="6.5" x2="11" y2="6.5" stroke={color} strokeLinecap="round" />
    </svg>
  )
}

export default withIcon(RemoveUserIcon)
